import React, {Component} from 'react';
import { ServiceCollectionParam } from "./ServiceCollection";
import { PreExamEventEntry } from "../common/TestInfo";
import { formatDate } from "../util";
import MessageProvider from "../classes/MessageProvider";
import MessageBox from "./MessageBox";
import { Link } from "react-router-dom";

interface State {
    rows: PreExamEventEntry[],
    userResult: {
        preExamRegistrationId: string | undefined,
        preExamRequirementsFilled: boolean
    }
}

export default class RegistrationPage extends Component<ServiceCollectionParam, {}> {

    messages = new MessageProvider(this.setState.bind(this));

    state: State = {
        rows: [],
        userResult: {
            preExamRegistrationId: undefined,
            preExamRequirementsFilled: false
        }
    };

    async componentDidMount() {
        await this.loadData();
    }

    async loadData() {
        const currentUser = this.props.services.auth.getAuthCredentials().userName;

        this.state.userResult = await this.props.services.dao.getProjectResultFor(currentUser);

        this.state.rows = await this.props.services.dao.getPreExamEvents(currentUser);

        const message = `Registreerimiseks peavad nõutud ülesanded esitatud olema`;

        if (!this.state.userResult.preExamRequirementsFilled) {
            this.messages.error(message);
        }

        this.setState({});
    }

    async register(eventId: string) {
        const currentUser = this.props.services.auth.getAuthCredentials().userName;

        await this.props.services.dao
            .registerToPreExam(currentUser, eventId)
            .catch(() => this.messages.error('Viga registreerimisel!'));

        await this.loadData();
    }

    async cancelRegistration() {
        const currentUser = this.props.services.auth.getAuthCredentials().userName;

        await this.props.services.dao.cancelPreExamRegistration(currentUser);

        await this.loadData();
    }

    render() {
        let isAdmin = this.props.services.uiSettings.isAdmin;

        const firstRow = this.state.rows[0];

        if (!firstRow) {
            return <p>Sündmused puuduvad</p>;
        }

        const typeLabel = firstRow.type === 'exam' ? 'Eksamile' : 'Kontrolltööle';

        return (
            <>

            <MessageBox messages={ this.messages.getMessages() } />

            <table className="table caption-top">
                <caption>{typeLabel} registreerimine</caption>

                <thead>
                <tr>
                    <th scope="col">Kuupäev</th>
                    <th scope="col">Registreerimise tähtaeg</th>
                    <th scope="col">Tühistamise tähtaeg</th>
                    <th scope="col">Kohti kokku</th>
                    <th scope="col">Vabu kohti</th>
                    <th scope="col">Märkus</th>
                    <th scope="col"></th>
                </tr>
                </thead>
                <tbody>
                { this.state.rows.map(row =>
                    <tr key={row.eventId}>
                        <td className="no-wrap">
                            {
                                isAdmin ?
                                    <Link to={`/registered-list/${row.eventId}`}>{formatDate(row.date)}</Link>
                                    : formatDate(row.date)
                            }
                        </td>
                        <td>{formatDate(row.deadline)}</td>
                        <td>{formatDate(row.cancelDeadline)}</td>
                        <td>{row.maxPlaces}</td>
                        <td>{row.freePlaces}</td>
                        <td>{row.note}</td>
                        <td style={{ textAlign: 'right', width: '8rem' }}>
                            {
                                row.registerAvailable ?
                                    <button
                                        onClick={() => this.register(row.eventId)}
                                        className="btn btn-success">Registreeri</button>
                                    : ''
                            }
                            {
                                row.eventId === this.state.userResult.preExamRegistrationId ?
                                    <button
                                        onClick={() => this.cancelRegistration()}
                                        disabled={row.cancelDisabled}
                                        className="btn btn-danger">Tühista registreerumine</button>
                                    : ''
                            }

                        </td>
                    </tr>)
                }

                </tbody>
            </table>
                {/** Lühike eksam tähendab, et soovin jätta kehtima ühe kontrolltöö tulemuse.<br />*/}
                {/*&nbsp;&nbsp;&nbsp;Pikk eksam tähendab, et kontrolltöö tulemusi ei soovi arvestada.*/}
                * Soovin teha kontrolltööd arvutiga ja nõustun ekraani salvestmisega.<br/>
                ** Ei nõustu ekraani salvestmisega ja soovin teha kontrolltööd paberil.
            </>);
    }

}
